import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Country, Condition } from '../../../api/interfaces/register';
import { TranslateService } from '@ngx-translate/core';
import { SharedDataService } from '../../../services/sharedData/shared-data.service';
import { FormValidatorService } from '../../../services/formValidator/form-validator.service';
import { MobileDetectorService } from '../../../services/mobileDetector/mobile-detector.service';


@Component({
  selector: 'app-step-three',
  templateUrl: './step-three.component.html',
  styleUrls: ['./step-three.component.scss']
})
export class StepThreeComponent implements OnInit {

  countrys: Country[];
  maxDate: Date = new Date();

  backgrounds: string[] = [];
  days: number[] = [0,1,2,3,4,5,6,7];
  complements: string[] = [];
  objetives: string[] = [];
  firstTime: boolean = false;
  showObjetives: boolean = false;
  showComplements: boolean = false;

  objetivesEmpty: boolean = false;
  objetivesValid: boolean = false;

  rutaValid: boolean = true;
  pistaValid: boolean = true;
  trailValid: boolean = true;
  ultraValid: boolean = true;

  isMobile: boolean = false;

  conditions: Condition[] = [
    {name:"Muy malo", selected: false, index: 0},
    {name:"Malo", selected: false, index: 1},
    {name:"Regular", selected: false, index: 2},
    {name:"Bueno", selected: false, index: 3},
    {name:"Muy bueno", selected: false, index: 4}
  ];

  backgroundForm = new FormGroup({
    background: new FormControl(),
    days: new FormControl(),
    trainingWeek: new FormControl(),
    condition: new FormControl(),
    complement: new FormControl(),
    restAndFood: new FormControl(),
    shoes: new FormControl(),
    
    ruta: new FormControl(),
    pista: new FormControl(),
    trail: new FormControl(),
    ultra: new FormControl(),

    objetives: new FormControl(),
  });


  constructor(
    private translate: TranslateService,
    private cdr: ChangeDetectorRef,
    private formValidatorService: FormValidatorService,
    private sharedData: SharedDataService,
    private mobileDetectorService: MobileDetectorService,
  ) { }

  ngOnInit(): void {

    this.isMobile = this.mobileDetectorService.isMobile();
    this.cdr.detectChanges();
    this.getAnswersQuestionOne();
    this.getAnswersQuestionFive();
    this.getObjetives();

    this.sharedData.currentMessage.subscribe(message => {
      if(message==="saveStep") {
        sessionStorage.setItem('background', JSON.stringify(this.backgroundForm.value));
      }
      if(message==="objetivesvalid") {
        this.objetivesValid = true;
      }

      if(message==="objetivesinvalid") {
        this.objetivesValid = false;
      }

    });

    this.backgroundForm.statusChanges
    .subscribe(val => {
      this.formValidatorService.onFormValidation(val, "step3","background");
      if(!this.backgroundForm.value.ruta) {
        sessionStorage.removeItem('ruta');
      }
      if(!this.backgroundForm.value.pista) {
        sessionStorage.removeItem('pista');
      }
      if(!this.backgroundForm.value.trail) {
        sessionStorage.removeItem('trail');
      }
      if(!this.backgroundForm.value.ultra) {
        sessionStorage.removeItem('ultra');
      }
    });
  }

  getAnswersQuestionOne() {
    this.translate
            .get([
              'registration.stepThree.question1.answer1',
              'registration.stepThree.question1.answer2',
              'registration.stepThree.question1.answer3',
              'registration.stepThree.question1.answer4',
            ])
            .subscribe(translations => {
                this.backgrounds.push(translations['registration.stepThree.question1.answer1']);
                this.backgrounds.push(translations['registration.stepThree.question1.answer2']);
                this.backgrounds.push(translations['registration.stepThree.question1.answer3']);
                this.backgrounds.push(translations['registration.stepThree.question1.answer4']);
            });
  }

  getAnswersQuestionFive() {
    this.translate
            .get([
              'registration.stepThree.genericAnswers.yes',
              'registration.stepThree.genericAnswers.no',
            ])
            .subscribe(translations => {
                this.complements.push(translations['registration.stepThree.genericAnswers.yes']);
                this.complements.push(translations['registration.stepThree.genericAnswers.no']);
            });
  }

  getObjetives() {
    this.translate
            .get([
              'registration.stepThree.objetives.answer1',
              'registration.stepThree.objetives.answer2',
            ])
            .subscribe(translations => {
                this.objetives.push(translations['registration.stepThree.objetives.answer1']);
                this.objetives.push(translations['registration.stepThree.objetives.answer2']);
            });
  }

  unselectAllConditions() {
    this.conditions.forEach(day => {
      day.selected = false;
    });
  }

  saveCondition(condition: Condition) {
    this.unselectAllConditions();
    this.backgroundForm.patchValue({ condition: condition });
    this.conditions[condition.index].selected = true;
  }

  changeObjetives(mode: boolean) {
    this.showObjetives = mode;
    this.objetivesEmpty = false;
    if (!mode) {
      this.objetivesValid = true;
      sessionStorage.removeItem('objetives');
    } else {
      this.objetivesValid = false;
    }
  }

  changeAchievement(aux) {
    if(aux.mode === "ruta") {
      this.rutaValid = aux.valid
    }

    if(aux.mode === "pista") {
      this.pistaValid = aux.valid
    }

    if(aux.mode === "ultra") {
      this.ultraValid = aux.valid
    }

    if(aux.mode === "trail") {
      this.trailValid = aux.valid
    }
  }

  changeFromCheckbox(mode: string) {
    /*
      Habilita el modo cuando se clickea en el checkbox para desactivarlo, previamente activado. 
      Si el resto del step es vá}lido puede continuar
    */
    if(mode == 'ruta' && !this.rutaValid) {
      this.rutaValid = true;
    }

    if(mode == 'pista' && !this.pistaValid) {
      this.pistaValid = true;
    }

    if(mode == 'trail' && !this.trailValid) {
      this.trailValid = true;
    }

    if(mode == 'ultra' && !this.ultraValid) {
      this.ultraValid = true;
    }
  }

  changeComplements(mode: boolean) {
    this.showComplements = mode;
    if(!mode) {
      this.backgroundForm.patchValue({complement: "No"});
    } else {
      this.backgroundForm.patchValue({complement: ""});
    }
  }

  emptyObjetives(mode: boolean) {
    this.objetivesEmpty = true;
  }

  emptyAchievement(mode: string) {
    if(mode === "ruta") {
      this.backgroundForm.patchValue({ruta: false});
    }
    if(mode === "pista") {
      this.backgroundForm.patchValue({pista: false});
    }
    if(mode === "trail") {
      this.backgroundForm.patchValue({trail: false});
    }
    if(mode === "ultra") {
      this.backgroundForm.patchValue({ultra: false});
    }
  }

}